import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=120108af&scoped=true&"
import script from "./basicSettings.vue?vue&type=script&lang=js&"
export * from "./basicSettings.vue?vue&type=script&lang=js&"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=120108af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120108af",
  null
  
)

export default component.exports